import { IGeocodeResult, IGeocodeErrorResult } from '../types/geocode';
import { IMakeRequest, isSuccessResponse } from '../../app/helpers/network_helper';

export function geocodeCached(
  makeRequest: IMakeRequest,
  query: string,
): Promise<IGeocodeResult> {
  return makeRequest({
    method: 'GET',
    uri: {
      path: `/api/geo/geocode-cached/?request=${encodeURIComponent(query)}`,
    },
  })
    .then((response: IGeocodeResult | IGeocodeErrorResult) => {
      if (!isSuccessResponse<IGeocodeResult, IGeocodeErrorResult>(response, 'items')) {
        throw new Error(`Failed to geocode '${query}'`);
      }

      return response;
    });
}
